const STATUS = {
  ACTION: 'Action',
  INACTION: 'InAction',
  PENDING: 'Pending',
  RECALL: 'Recall',
}
const SPACE_ROLE = {
  ROLE_ORGANIZATION: 'ROLE_ORGANIZATION',
  ROLE_INDIVIDUAL: 'ROLE_INDIVIDUAL',
}

const WORKSPACE = {
  STATUS,
  SPACE_ROLE,
}

export default WORKSPACE
